import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import cx from 'classnames';

import navActions from '../../actions/nav.actions';
import {svgs} from 'epic-diesel-common/src/constants';

import NavItem from './NavItem';

import styles from './Nav.pcss';

import userAvatar from './fortniteAvatar.png';

const mockNavLoggedIn = {
    header: {
        avatar: userAvatar,
        firstInitial: 'D',
        id: 1,
        subtitle: '$23.58',
        title: 'Dr_Respect',
        to: '/'
    },
    top: [
        {
            icon: svgs.HOME,
            id: 2,
            title: '',
            to: '/'
        },
        {
            icon: svgs.SQUARE,
            id: 3,
            title: '',
            to: '/'
        },
        {
            icon: svgs.STORE,
            id: 4,
            title: '',
            to: '/'
        },
        {
            icon: svgs.LINK,
            iconClass: styles.iconLink,
            id: 5,
            title: '',
            to: '/'
        },
        {
            icon: svgs.FRIENDS,
            id: 6,
            title: '',
            to: '/'
        }
    ],
    bottom: [
        {
            icon: svgs.SEARCH,
            id: 8,
            title: '',
            to: '/'
        },
        {
            icon: svgs.SETTINGS,
            id: 9,
            title: '',
            to: '/'
        }
    ]
};

const mockNavLoggedOut = {
    header: {
        icon: svgs.EPIC,
        id: 1,
        title: 'diesel.main.navigation.log_in',
        to: '/'
    },
    top: [
        {
            icon: svgs.HOME,
            id: 2,
            title: 'diesel.main.navigation.home',
            to: '/'
        },
        {
            icon: svgs.LIBRARY,
            id: 3,
            title: 'diesel.main.navigation.library',
            to: '/'
        },
        {
            icon: svgs.STORE,
            id: 4,
            title: 'diesel.main.navigation.store',
            to: '/'
        }
    ],
    bottom: [
        {
            icon: svgs.SEARCH,
            id: 5,
            title: 'diesel.main.navigation.search',
            to: '/'
        },
        {
            icon: svgs.SETTINGS,
            id: 6,
            title: 'diesel.main.navigation.settings',
            to: '/'
        }
    ]
};

const mapStateToProps = state => ({
    isExpanded: state.getIn(['nav', 'isExpanded'])
});

const mapDispatchToProps = dispatch => ({
    triggerMouseEnter: () => {
        dispatch(navActions.startHover());
    },
    triggerMouseLeave: () => {
        dispatch(navActions.endHover());
    }
});

class Nav extends PureComponent {
    static propTypes = {
        isExpanded: PropTypes.bool.isRequired,
        isLoggedIn: PropTypes.bool.isRequired,
        triggerMouseEnter: PropTypes.func.isRequired,
        triggerMouseLeave: PropTypes.func.isRequired
    };

    mouseEnter = () => {
        this.props.triggerMouseEnter();
    };

    mouseLeave = () => {
        this.props.triggerMouseLeave();
    };

    render() {
        const {isExpanded, isLoggedIn} = this.props;

        const navClasses = cx(styles.nav, {[styles.expanded]: isExpanded});

        const data = isLoggedIn ? mockNavLoggedIn : mockNavLoggedOut;

        return (
            <div
                // onMouseEnter={this.mouseEnter}
                // onMouseLeave={this.mouseLeave}
                className={navClasses}>
                <NavItem isHeader={true} {...data.header} />

                <hr className={styles.divider} />

                <div className={styles.panel}>
                    <div>
                        {data.top.map(item => (
                            <NavItem {...item} key={item.id} />
                        ))}
                    </div>
                    <div>
                        {data.bottom.map(item => (
                            <NavItem {...item} key={item.id} />
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Nav);
